
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            this.Iniciar();
        }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Iniciar();
        }

        Iniciar()
        {
            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Filtros[key] = Number( this.Buscador.Filtros.Valores[key] );
            }
            //this.Transporte = this.Buscador.Filtros.Valores.Logistica;
        }


        public Filtros: Record<string, number> = {
            Tag: 0,
            Cuenta: 0,
            Estado: 0,
            Tipo: 0,
            TiposArticulo: 0,
            Limite: 1,
            Orden: 0,
            Indice: 0,
            EnvioGratis: 0,
        };

        public async Filtrar()
        {
            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Buscador.Filtros.Valores[key] = this.Filtros[key];
            }


            //if ( this.Cliente )
            //    this.Buscador.Filtros.Valores.Cliente = this.Cliente;

            await this.Buscador.Buscar( 1 );
            this.Cerrar();
        }

        Cerrar()
        {
            this.Abierto = false;
            this.Controlador.Vista.Filtros.Abierto = false;
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
